module.exports = __webpack_public_path__ + "498575067a35a241ba0ba1d54a2dc6c0.png";